const addToCartPinterest=(productId)=> {
    pintrk('track', 'addtocart', {
     
      currency: 'USD', 
      order_quantity: 1,
      product_id: productId 
    });
  }

window.addEventListener("click",(event)=>{
    let {target} = event;

if(target.classList.contains('product-form__submit') && target.closest('product-form')){



    const id = target.closest('form').querySelector('[name="id"]').value;

    addToCartPinterest(id)


}




})